import { CalendarIcon, DropletsIcon, LightbulbIcon, RecycleIcon, SeedIcon, SprayIcon, SproutIcon, WateringCanIcon } from './HomeIcons';

const howtoVermi = [
  { icon: <LightbulbIcon className="ui-icon step-svg-icon" />, title: 'Loosen the Soil', desc: 'Use a garden hoe or cultivator to aerate the soil before application.' },
  { icon: <SproutIcon className="ui-icon step-svg-icon" />, title: 'Apply Near Roots', desc: 'Sprinkle vermicompost evenly near the root zone of your plants.' },
  { icon: <WateringCanIcon className="ui-icon step-svg-icon" />, title: 'Water Thoroughly', desc: 'Water immediately after application to help nutrients penetrate the soil.' },
  { icon: <CalendarIcon className="ui-icon step-svg-icon" />, title: 'Repeat Every 45-60 Days', desc: 'For best results, reapply throughout the growing season.' }
];

const howtoVermiwash = [
  { icon: <SprayIcon className="ui-icon step-svg-icon" />, title: 'Foliar Spray', desc: 'Mix 100ml in 1 litre water. Spray directly on leaves every 10-15 days.' },
  { icon: <DropletsIcon className="ui-icon step-svg-icon" />, title: 'Soil Drench', desc: 'Mix 100-150ml per litre and apply near the root zone biweekly.' },
  { icon: <SeedIcon className="ui-icon step-svg-icon" />, title: 'Seed Treatment', desc: 'Soak seeds in 50ml per litre solution for 6-8 hours before sowing.' },
  { icon: <RecycleIcon className="ui-icon step-svg-icon" />, title: 'Compost Booster', desc: 'Add 200ml per 5kg compost to accelerate microbial decomposition.' }
];

export default function ApplicationGuideSection() {
  return (
    <section className="section alt howto-section" id="how-to-use" aria-label="Application guide">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">Application Guide</span>
          <h2 className="section-title">How to Use for Best Results</h2>
          <p className="section-desc">Simple, effective application methods for both products - for home gardeners and professional farmers alike.</p>
        </div>
        <div className="howto-split">
          <div className="howto-col">
            <div className="howto-col-title"><SproutIcon className="ui-icon howto-title-icon" />Vermicompost Application</div>
            <div className="howto-steps">
              {howtoVermi.map((step, i) => (
                <div key={i} className="howto-step">
                  <div className="step-icon" aria-hidden="true">{step.icon}</div>
                  <div>
                    <div className="step-title">{step.title}</div>
                    <div className="step-desc">{step.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="howto-col">
            <div className="howto-col-title"><DropletsIcon className="ui-icon howto-title-icon" />Vermiwash Application</div>
            <div className="howto-steps">
              {howtoVermiwash.map((step, i) => (
                <div key={i} className="howto-step">
                  <div className="step-icon" aria-hidden="true">{step.icon}</div>
                  <div>
                    <div className="step-title">{step.title}</div>
                    <div className="step-desc">{step.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="howto-note">
              <span className="howto-note-icon"><LightbulbIcon className="ui-icon note-svg-icon" /></span>
              <span><strong>Pro Tip:</strong> For foliar spray, apply early morning or evening - avoid direct afternoon sun. Mix thoroughly and use fresh.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
